import React from 'react';
import PropTypes from 'prop-types';

import { PdpSharedSourcingModalLoader } from './PdpSharedSourcingModalLoader';

export class PdpSharedSourcingModalLoaderWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isModalOpen: props.isOpen || false,
        };

        this.closeModal = this.closeModal.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!this.state.isModalOpen && !prevProps.isOpen && this.props.isOpen) {
            this.setState({ isModalOpen: this.props.isOpen });
        }
    }

    closeModal() {
        this.setState({ isModalOpen: false });
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    render() {
        return (
            <PdpSharedSourcingModalLoader
                environment={this.props.environment}
                isOpen={this.state.isModalOpen}
                itemId={this.props.itemId}
                onClose={this.closeModal}
                showInitialPrompt={this.props.showInitialPrompt}
            />
        );
    }
}

PdpSharedSourcingModalLoaderWrapper.propTypes = {
    environment: PropTypes.object.isRequired,
    itemId: PropTypes.string.isRequired,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    showInitialPrompt: PropTypes.bool,
};
